import effects from 'app/effects/effects'
import * as R from 'ramda'
import moment from 'moment'
import { addExpiresAt } from './tokenHelper'
import { all } from 'bluebird'
import { rejectOnSuspended } from './suspendStatus'
import {
  rejectOnFreeTierButNotRootAdmin,
  rejectOnRestrictedPlanButNotRootAdmin,
} from './paidPlanAccess'

const getPlaceById = (getPlaceById) =>
  R.ifElse(
    R.isNil,
    () => Promise.reject('cannot get place id is undefined'),
    getPlaceById,
  )

export const refreshTokenWithProfile = () =>
  effects.apis.refreshTokenManager().then(loadProfileAndPlaceWithToken)

export const loginWithProfile = ({ username, password, isKeepMeSignedIn }) =>
  effects.apis
    .login({ username, password, isKeepMeSignedIn })
    .then(loadProfileAndPlaceWithToken)

export const loginWithSSO = ({ token }) =>
  effects.apis.loginWithSSO({ token }).then(loadProfileAndPlaceWithToken)

export const loadProfileAndPlaceWithToken = (credentials) => {
  return all([
    effects.apis.me(credentials.accessToken).then(rejectOnSuspended),
  ]).then(([user, awsCredential]) =>
    getPlaceById(effects.apis.getPlaceById(credentials.accessToken))(
      R.view(R.lensPath(['id']), R.head(user.places)),
    )
      .then((place) =>
        Promise.resolve({
          token: addExpiresAt(moment(), credentials),
          user,
          place,
          awsCredential,
        }),
      )
      .then(rejectOnRestrictedPlanButNotRootAdmin)
      .then(rejectOnFreeTierButNotRootAdmin),
  )
}

export const loadProfileAndPlace = () =>
  effects.apis
    .getAdminProfile()
    .then(rejectOnSuspended)
    .then((user) =>
      getPlaceById(effects.apis.getPlaceByIdAuth)(
        R.view(R.lensPath(['id']), R.head(user.places)),
      ).then((place) =>
        Promise.resolve({
          user,
          place,
        }),
      ),
    )
    .then(rejectOnFreeTierButNotRootAdmin)

export const registerWithProfile = (model) =>
  effects.apis.register(model).then(() => {
    return loginWithProfile({
      username: model.email,
      password: model.password,
    })
  })

export const activatePlaceAndGetPlaceProfileAndUserProfileAPI = (
  tokenFromMail,
) =>
  effects.apis.activatePlace(tokenFromMail).then(loadProfileAndPlaceWithToken)
